const portfolioList = [
  {
    id: 1,
    name: "에코씨씨",
    type: "표준형",
    imageUrl: "web01",
    url: "http://ecocc.co.kr/",
  },
  {
    id: 2,
    name: "타코잉닭",
    type: "원페이지형",
    imageUrl: "web46",
    url: "http://takoing.com",
  },
  {
    id: 2,
    name: "참숯 삼인조",
    type: "원페이지형",
    imageUrl: "web02",
    url: "http://corenweb2022.cafe24.com/",
  },
  {
    id: null,
    name: "제이파렛트",
    type: "원페이지형",
    imageUrl: "web42",
    url: "https://jp2022.cafe24.com/",
  },
  {
    id: null,
    name: "가원법률사무소",
    type: "원페이지형",
    imageUrl: "web10",
    url: "http://gawon112.co.kr/",
  },
  {
    id: null,
    name: "용인수상스키",
    type: "원페이지형",
    imageUrl: "web28",
    url: "https://sk2022.cafe24.com/",
  },
  {
    id: null,
    name: "와우킹드라이브",
    type: "원페이지형",
    imageUrl: "web04",
    url: "http://158.247.196.248:9001/",
  },
  {
    id: null,
    name: "교석서점",
    type: "원페이지형",
    imageUrl: "web48",
    url: "https://kg2023.cafe24.com",
  },
  {
    id: null,
    name: "포이스",
    type: "원페이지형",
    imageUrl: "web47",
    url: "https://pois2023.cafe24.com",
  },
  {
    id: 3,
    name: "단디자인",
    type: "표준형",
    imageUrl: "web03",
    url: "http://www.corendesign.net/dann/",
  },
  // {
  //   id: 4,
  //   name: "와우킹드라이브",
  //   type: "원페이지형",
  //   imageUrl: "web04",
  //   url: "http://158.247.196.248:9001/",
  // },
  {
    id: 5,
    name: "명가생아구찜",
    type: "표준형",
    imageUrl: "web05",
    url: "http://myeong-ga.co.kr/#/",
  },
  {
    id: 6,
    name: "플러스간호학원",
    type: "표준형",
    imageUrl: "web06",
    url: "http://www.plusnurse.kr/",
  },
  {
    id: 29,
    name: "바로북",
    type: "심화개발형",
    imageUrl: "web29",
    url: "https://www.barobook.co.kr/",
  },
  {
    id: 7,
    name: "바른미이비인후과",
    type: "심화개발형",
    imageUrl: "web07",
    url: "http://ba2021.cafe24.com/",
  },
  // {
  //   id: 8,
  //   name: "한국장애인농축산협회",
  //   type: "표준형",
  //   imageUrl: "web08",
  //   url: "http://isw.or.kr/",
  // },
  // {
  //   id: 9,
  //   name: "패밀리쿡",
  //   type: "표준형",
  //   imageUrl: "web09",
  //   url:"https://fm2021.cafe24.com/",
  // },
  // {
  //   id: 10,
  //   name: "액큐",
  //   type: "쇼핑몰",
  //   imageUrl: "web10",
  //   url: "https://coren001.cafe24.com/",
  // },
  {
    id: 11,
    name: "생림비철금속",
    type: "표준형",
    imageUrl: "web11",
    url: "http://slmetal.co.kr/",
  },
  {
    id: 12,
    name: "미래인성교육원",
    type: "표준형",
    imageUrl: "web12",
    url: "http://miraeins.co.kr/",
  },
  // {
  //   id: 13,
  //   name: "스타트업기업인협회",
  //   type: "표준형",
  //   imageUrl: "web13",
  //   url: "http://corenbs.com/g5/",
  // },
  {
    id: 14,
    name: "지오리서치",
    type: "심화개발형",
    imageUrl: "web14",
    url: "http://go2022.cafe24.com/",
  },
  // {
  //   id: 15,
  //   name: "엠에스글로벌바이오",
  //   type: "표준형",
  //   imageUrl: "web15",
  //   url: "https://icube2021.cafe24.com/",
  // },
  {
    id: 16,
    name: "엠에스글로벌바이오",
    type: "심화개발형",
    imageUrl: "web16",
    url: "http://msg2022.cafe24.com/",
  },
  {
    id: null,
    name: "네이처과학학원",
    type: "심화개발형",
    imageUrl: "web45",
    url: "https://science2022.cafe24.com/",
  },
  // {
  //   id: 17,
  //   name: "수과일",
  //   type: "쇼핑몰",
  //   imageUrl: "web17",
  //   url: "https://jda2021.cafe24.com/",
  // },
  {
    id: 18,
    name: "홍탄버너",
    type: "쇼핑몰",
    imageUrl: "web18",
    url: "http://xn--h50bu1tlmq6gf.com/",
  },
  {
    id: 19,
    name: "더줌푸드",
    type: "표준형",
    imageUrl: "web19",
    url: "http://corenfs.com/thezoom/",
  },
  // {
  //   id: 20,
  //   name: "코랜펫",
  //   type: "쇼핑몰",
  //   imageUrl: "web20",
  //   url: "https://corenpet.com/",
  // },
  {
    id: 21,
    name: "일월세라믹",
    type: "표준형",
    imageUrl: "web21",
    url: "http://www.iwceramics.com/",
  },
  {
    id: 22,
    name: "꽁꽁박사",
    type: "원페이지형",
    imageUrl: "web22",
    url: "http://corendesign2021.cafe24.com/%EA%BD%81%EA%BD%81%EB%B0%95%EC%82%AC/",
  },
  // {
  //   id: 23,
  //   name: "황제에어컨",
  //   type: "원페이지형",
  //   imageUrl: "web23",
  //   url: "http://emperor2021.cafe24.com/",
  // },
  // {
  //   id: 24,
  //   name: "차이나콩",
  //   type: "심화개발형",
  //   imageUrl: "web24",
  //   url: "http://chinakong.co.kr/",
  // },
  {
    id: 25,
    name: "헤라플",
    type: "쇼핑몰",
    imageUrl: "web25",
    url: "https://coren002.cafe24.com/index.php",
  },
  {
    id: 26,
    name: "봄날앤",
    type: "쇼핑몰",
    imageUrl: "web26",
    url: "http://bomnaland.com/",
  },
  {
    id: 27,
    name: "지우스",
    type: "쇼핑몰",
    imageUrl: "web27",
    url: "https://jioos.com/",
  },
  {
    id: 28,
    name: "상윤네트웍스",
    type: "표준형",
    imageUrl: "web28",
    url: "http://sangyunnetworks.cafe24.com/",
  },
  // {
  //   id: 30,
  //   name: "모쿠",
  //   type: "표준형",
  //   imageUrl: "web30",
  //   url: "http://globalmokoo.cafe24.com/kr/kr.html",
  // },
  {
    id: 31,
    name: "팔봉",
    type: "표준형",
    imageUrl: "web31",
    url: "http://palbong.co.kr/",
  },
  {
    id: 32,
    name: "가원법률사무소",
    type: "표준형",
    imageUrl: "web32",
    url: "http://gawon2021.cafe24.com/",
  },
  {
    id: 33,
    name: "대구골프협회",
    type: "표준형",
    imageUrl: "web33",
    url: "http://dgga.org/",
  },
  {
    id: 34,
    name: "이치우커피학원",
    type: "표준형",
    imageUrl: "web34",
    url: "http://www.lcwcoffeebaristaschool.com/",
  },
]

export default portfolioList;